import {getCurrentInstance} from 'vue';

export function useRequestTracing() {
	if (import.meta.server && !getCurrentInstance()) {
		return {requestId: undefined, correlationId: undefined};
	}

	let nuxtApp;
	try {
		nuxtApp = useNuxtApp();
	} catch (error) {
		return {requestId: undefined, correlationId: undefined};
	}

	const requestId = nuxtApp.ssrContext?.event.context.requestId;
	const correlationId = nuxtApp.ssrContext?.event.context.correlationId;

	return {requestId, correlationId};
}
